import { Extension } from '@tiptap/core'
import { Plugin, PluginKey } from 'prosemirror-state'
import { Fragment, Mark, Node, Slice } from 'prosemirror-model'
import Helper from '../../../helpers/Helper'

export const ColorNormalizer = Extension.create({
    name: 'colorNormalizer',

    addProseMirrorPlugins() {
        return [
            new Plugin({
                key: new PluginKey('colorNormalizer'),
                props: {
                    transformPasted(slice) {
                        const fragment = slice.content
                        const nodes: any[] = []

                        fragment.forEach(node => {
                            nodes.push(transformNode(node))
                        })

                        const newFragment = Fragment.from(nodes)
                        return new Slice(newFragment, slice.openStart, slice.openEnd)
                    }
                }
            })
        ]
    }
})

const transformNode = (node: Node) => {
    if (node.isText && node.marks) {
        const newMarks = node.marks.map((mark: Mark) => {
            if (mark.type.name === 'textStyle' && mark.attrs.color) {
                const hexColor = Helper.rgbToHex(mark.attrs.color)
                if (hexColor !== mark.attrs.color) {
                    return mark.type.create({
                        ...mark.attrs,
                        color: hexColor
                    })
                }
            }
            return mark
        })

        if (newMarks !== node.marks) {
            return node.mark(newMarks)
        }
    }

    if (node.content && node.content.size > 0) {
        const newContent: any[] = []
        node.content.forEach((child: any) => {
            newContent.push(transformNode(child))
        })

        return node.copy(Fragment.from(newContent))
    }

    return node
}
